import Api from '@/services/Api'

export default {
  show (params) {
    return Api().post('deviceMode', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/DeviceModeService.js